import { createSlice } from '@reduxjs/toolkit';
import reducer from './reducer';

const initialState = {
  list: [],
  viewItem: undefined,
  filter: {},
};

export default createSlice({
  name: 'webhookRegistration',
  initialState,
  reducers: reducer,
});
